import { useContext, useState } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow';
import type { EdgeProps } from 'reactflow';
import { EdgeActionsContext } from '../EdgeActionsContext';

export function DeletableEdge({
  id,
  sourceX, sourceY, sourcePosition,
  targetX, targetY, targetPosition,
  markerEnd,
  style,
}: EdgeProps) {
  const { deleteEdge } = useContext(EdgeActionsContext);
  const [hovered, setHovered] = useState(false);

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition,
    targetX, targetY, targetPosition,
  });

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); deleteEdge(id); }}
            style={{ opacity: hovered ? 1 : 0, transition: 'opacity 0.15s' }}
            className="w-5 h-5 bg-card border border-border rounded-full text-muted-foreground hover:text-destructive hover:border-destructive flex items-center justify-center text-xs leading-none shadow-sm"
            title="Delete connection"
          >
            ×
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
